import {CheckboxUniqueSelectClickEvent} from "../../../events/Events";
import {EventBus} from "../../../events/EventBus";


export class SelectBody {
    private inputs: HTMLInputElement[]
    private onChangeCallback: (values: string[], inputValues: string[], input: HTMLInputElement) => void
    private eventBus = EventBus.getInstance();

    constructor(
        element: HTMLElement,
        multiSelect: boolean,
        allowDeselect: boolean,
        onChangeCallback: (
            values: string[],
            inputValues: string[],
            input: HTMLInputElement
        ) => void) {
        this.onChangeCallback = onChangeCallback
        this.inputs = Array.from(element.querySelectorAll('.wl-checkbox-unique-select__options__option__input')) as HTMLInputElement[];
        this.whenClicked(this.inputs, (input) => {
            if (!allowDeselect) {
                this.dontAllowDeselect(input);
            }
            if (!multiSelect) {
                this.deselectOthers(input);
            }
            this.onChangeCallback(this.selectedValuesText(), this.selectedValues(), input)
            this.notifyClicked(input);
        });
    }

    private dontAllowDeselect(input: HTMLInputElement) {
        if (!input.checked) {
            input.checked = true;
        }
    }

    private whenClicked(inputs: HTMLInputElement[], callback: (input: HTMLInputElement) => void) {
        inputs.forEach((input: HTMLInputElement) => {
            input.addEventListener('click', () => callback(input))
        })
    }

    selectedValuesText() {
        return this.inputs
            .filter((input) => input.checked)
            .map((input) => input.dataset.textvalue || "");
    }

    selectedValues() {
        return this.inputs
            .filter((input) => input.checked)
            .map((input) => input.value || "");
    }

    private deselectOthers(currentInput: HTMLInputElement) {
        this.inputs
            .forEach((input: HTMLInputElement) => {
                if (input.value !== currentInput.value) {
                    input.checked = false;
                }
            });
    }

    deselectAll() {
        this.inputs
            .forEach((input: HTMLInputElement) => {
                input.checked = false;
            });
    }

    private notifyClicked(input: HTMLInputElement) {
        this.eventBus.emit(new CheckboxUniqueSelectClickEvent({
            inputName: input.name,
            inputValue: input.value,
            inputChecked: input.checked,
            inputText: input.dataset.textvalue!,
        }));
    }

    checkValues(valuesToCheck: number[]) {
        this.inputs.forEach((input: HTMLInputElement) => {
            if (valuesToCheck.includes(parseInt(input.value))) {
                input.checked = true;
            }
        });
    }
}
